import _ from 'lodash';

/**
 * Robert Penner easing function: easeInOutSine
 * https://github.com/bcherny/penner/blob/master/penner.js#L104
 * @param {number} t - current time (ms, s, frames, ...)
 * @param {number} b - initial value
 * @param {number} c - change in value (final value - initial value)
 * @param {number} d - duration (same units as t)
 */
export const easeInOutSine = (t, b, c, d) => {
    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
};

/**
 * Return maximum scrollable height.  On most devices we get it from documentElement
 * but on mobile web view (used by Venice) from the body
 */
const getMaxScrollHeight = (win) => {
    const rootHeight = _.get(win, 'document.documentElement.scrollHeight');
    const bodyHeight = _.get(win, 'document.body.scrollHeight');

    if (_.isNumber(rootHeight) && _.isNumber(bodyHeight)) {
        return Math.max(rootHeight, bodyHeight);
    } else if (_.isNumber(rootHeight)) {
        return rootHeight;
    } else if (_.isNumber(bodyHeight)) {
        return bodyHeight;
    }
    return -1;
};

/**
 * Return starting y position for scrolling.  MAX_VALUE returned if lookup fails
 */
const getScrollStart = (win) => {
    const scrollY = _.get(win, 'scrollY');
    if (_.isNumber(scrollY)) {
        return scrollY;
    }

    const pageYOffset = _.get(win, 'pageYOffset');
    if (_.isNumber(pageYOffset)) {
        return pageYOffset;
    }

    return Number.MAX_VALUE;
};

/**
 * Creates a scrollTo animation at call time, then executes it.
 * NOTE: if the height of the page changes while the animation is
 * running, then the user might not get to the bottom of the page
 * (since y positions are calculated at call-time).
 * @param {object} win - The global window object
 * @param {number} duration - the duration of the animation (in milliseconds)
 * @param {number} frameTime - the duration of a frame (in milliseconds)
 */
export const scrollToBottom = (win, duration, frameTime = 15) => {
    const start = getScrollStart(win);
    const end = getMaxScrollHeight(win);

    if (start < end) {
        const steps = [];
        const runAnimation = () => {
            if (steps.length) {
                win.scrollTo(0, steps.shift());
                setTimeout(runAnimation, frameTime);
            }
        };

        const diff = end - start;
        let curr = 0;
        // build steps
        for (let time = 0; time <= duration; time += frameTime) {
            curr = easeInOutSine(time, start, diff, duration);
            steps.push(curr);
        }
        // ensure we get to the bottom
        if (curr < end) {
            steps.push(end);
        }
        // kick off animation
        runAnimation();
    } else {
        capeLog && capeLog(`scrollToBottom aborted start=${start} end=${end}`);
    }
};
